import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { MensajeCapcha } from "../../mensajes";
import { Mensaje, MensajeSiNo } from "../../mensajes2";

import {
  ValidCaptcha,
  validaSoloNumero,
  formatMoneda,
  validaMonto,
  seleccionarCampo,
  validaNumeroTelefono,
  validaEmail,
} from "../../../util/varios";
import CatalogoInmueble from "../../../catalogos/catalogoInmueble";
import CatalogoActividadEconomica from "../../../catalogos/catalogoActividadEconomica";
import CatalogoUsuarioWeb from "../../../catalogos/catalogoUsuarioWeb";
import "react-tabs/style/react-tabs.css";
import axios from "axios";
import CatalogoPersona from "../../../catalogos/catalogoPersona";
import TablaDeudaComercio from "./tablaDeudaComercios";
import TablaPagosComercio from "./tablaPagosComercios";
import TablaFacturasContribuyente from "./tablaFacturasContribuyentes";
import TablaHistoricoRetenciones from "./tablaHistoricoRetenciones";
import TablaMultasComercio from "./tablaMultasComercios";

import useTableFijo from "../../useTableFijo";
import moment from "moment";
import TablaFacturasPagas from "./tablaRelacionFactPagadas";
import TablaPagosEtax from "./tablaPagosEtax";
import TablaOtrosPagosEtax from "./tablaOtroPagoEtax";
import { Dimmer } from "../../spinner";
import { Input, SearchInput, Select, Textarea, Radio, Checkbox } from "../../../ui/inputs/Input";
import { DangerButton, PrimaryButton, SuccessButton } from "../../../ui/buttons/Button";
import MapaLocalizacion from "./mopaContriuyente";

const headCells = [
  {
    id: "codigoactividad",
    label: "CODIGO ACTIVIDAD",

    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    fontSize: "10px",
  },
  {
    id: "codigociu",
    label: "CODIGO CIU",

    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    fontSize: "10px",
  },
  {
    id: "descripcion",
    label: "DESCRIPCION",

    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    fontSize: "10px",
  },
  {
    id: "alicuota",
    label: "ALICUOTA",

    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    fontSize: "10px",
  },
  {
    id: "minimo",
    label: "MINIMO",

    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    fontSize: "10px",
  },
  {
    id: "accion",
    label: "OPCIONES",

    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    fontSize: "10px",
  },
];

export const ActualizarComercio = (props) => {

  let token = localStorage.getItem("jwtToken");
  let op = require("../../../../src/modulos/datos");

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [tabs, setTabs] = useState({
    class1: "nav-link active bg-blue-100 text-light rounded h-100",
    select1: "true",
    content1: "tab-pane fade show active px-0",
    class2: "nav-link bg-blue-200 text-light rounded",
    select2: "false",
    content2: "tab-pane fade",
  });
  const [espiritu] = useState(localStorage.getItem("espiritu"));

  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [mostrar4, setMostrar4] = useState(false);
  const [mostrar6, setMostrar6] = useState(false);
  const [mostrar7, setMostrar7] = useState(false);
  const [visible, setVisible] = useState(false);
  const [activate, setActivate] = useState(false);
  const [idActividad, setIdActividad] = useState(0);
  const [idComercio, setIdComercio] = useState()
  const [ritm, setRitm] = useState('');
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema")
  );
  const [coordenadas, setCoordenadas] = useState({
    latitud: props.comercio ? props.comercio.latitud : null,
    longitud: props.comercio ? props.comercio.longitud : null
  });


  const [factorCambio, setFactorCambio] = useState(0);
  const txtIdComercio = useRef();
  const cmbRif = useRef("");
  const txtRif = useRef();
  const txtRitm = useRef();
  const txtCodCatastro = useRef();
  const txtNumLicencia = useRef();
  const txtNumPatente = useRef();
  const txtDenominacionCome = useRef();
  const txtDireccionContri = useRef();
  const txtSectorUrbano = useRef();
  const txtSectorCatastral = useRef();
  const txtTlfContri = useRef();
  const txtCodActividad = useRef();
  const txtAlicuota = useRef();
  const txtDescripcionActi = useRef();
  const txtEmailContri = useRef();
  const txtCredito = useRef();
  const txtCedula = useRef();
  const txtNombreRespon = useRef();
  const txtApellidoRespon = useRef();
  const txtDireccionRespon = useRef();
  const txtEmailRespon = useRef();
  const txtTlfRespon = useRef();
  const txtCelRespon = useRef();
  const txtFechaNac = useRef();
  const cmbNacionalidad = useRef();
  const cmbSexo = useRef();
  const txtCodigoInm = useRef();
  const txtNombrePropie = useRef();
  const txtCodCatastroInm = useRef();
  const txtNumRegistro = useRef();
  const txtFechaInscripcion = useRef();
  const txtIslr = useRef();
  const txtCapPag = useRef();
  const txtCapSub = useRef();
  const cmbTipCont = useRef();
  const cmbClaseCont = useRef();
  const cmbStatus = useRef();
  const txtObserStatus = useRef();
  const cmbMes = useRef();
  const cmbAnio = useRef();
  const chkAgente = useRef();
  const txtFechaInscripcionlic = useRef();
  const txtNumEmpleados = useRef();
  const txtNumTecnicos = useRef();
  const txtNumObreros = useRef();
  const txtTipoNegocio = useRef();
  const chkRecRegComercio = useRef();
  const chkRecRif = useRef();
  const chkRecCedulaRep = useRef();
  const chkRecBalaceGeneral = useRef();
  const chkRecBalaceComprobacion = useRef();
  const chkRecBalaceGanancias = useRef();
  const chkRecDeclaracionIsrl = useRef();
  const chkRecActaConstitutiva = useRef();
  const chkRecSolvenciaMunicipal = useRef();
  const chkExonIntereses = useRef();
  const chkExonMultas = useRef();
  const chkExonRecargos = useRef();
  const radioDeclaraSi = useRef();
  const radioDeclaraNo = useRef();
  const chkAcreditacion = useRef();
  const chkConvenio = useRef();
  const txtFechaEmisionPate = useRef();
  const txtCodigoUsu = useRef();
  const txtLogin = useRef();
  const txtNombreUsu = useRef();
  const [contar1, setContar1] = useState(0);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [habilitadoNR, setHabilitadoNR] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [operacionPer, setOperacionPer] = useState(0);
  const [tecla, setTecla] = useState();
  const [cual, setCual] = useState(0);
  const [anio, setAnio] = useState([]);
  const [idUsuario, setIdUsuario] = useState();
  const [declaWeb, setDeclaWeb] = useState();
  const [eliminarActividadxComer, setEliminarActividadxComer] = useState();
  const [records, setRecords] = useState([]);
  const [filterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  let heightTabla = 320;

  const { TblContainer, TblHead, recordsAfterPagingAndSorting } = useTableFijo(
    records,
    headCells,
    filterFn,
    heightTabla
  );
  const procesarRegistro = (body) => {
    let endpoint = `${op.conexion}/api/industria/actualizarcomercio/${operacion}`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setActivate(false);
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "El contribuyente " +
                response.data.idcomer +
                " ha sido registrado de manera satisfactoria.",
              icono: "exito",
            });
            if (props.licencia) {
              props?.onHideAcepta()
            }
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "El contribuyente " +
                response.data.idcomer +
                " ha sido Editado de manera satisfactoria.",
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "El contribuyente " +
                response.data.idcomer +
                " ha sido Eliminado de manera satisfactoria.",
              icono: "exito",
            });
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  // Función callback que se ejecuta cuando cambia la ubicación en el mapa
  // Función callback que se ejecuta cuando cambia la ubicación en el mapa
  const handleLocationChange = (lat, lng) => {
    setCoordenadas({
      latitud: lat,
      longitud: lng
    });
    console.log('Coordenadas actualizadas:', lat, lng);
  };
  
  const datosRes = (cedula) => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.ingresa === 0) {
            txtNombreRespon.current.value = "";
            txtApellidoRespon.current.value = "";
            txtDireccionRespon.current.value = "";
            txtEmailRespon.current.value = "";
            txtTlfRespon.current.value = "";
            txtCelRespon.current.value = "";
            txtFechaNac.current.value = "";
            cmbNacionalidad.current.value = "V";
            cmbSexo.current.value = "M";
          }

          setHabilitadoNR(true);

          if (response.data !== "") {
            setHabilitadoNR(false);
            setOperacionPer(0);
            txtNombreRespon.current.value = response.data.nombres;
            txtApellidoRespon.current.value = response.data.apellidos;
            txtDireccionRespon.current.value = response.data.direccion;
            txtEmailRespon.current.value = response.data.correoe;
            txtTlfRespon.current.value = response.data.tlf1;
            txtCelRespon.current.value = response.data.tlf2;
            txtFechaNac.current.value = response.data.fnacimiento;
            cmbNacionalidad.current.value = response.data.nacionalidad;
            cmbSexo.current.value = response.data.sexo;
            if (tecla === 13) {
              txtCodigoInm.current.focus();
            }
          } else {
            setOperacionPer(1);
            setHabilitadoNR(true);
            if (tecla === 13) {
              setTimeout(() => {
                txtNombreRespon.current.focus();
              }, 100);
            }
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const datosUsuW = (idusuarioweb) => {
    let campos = "*";
    let nomtab = "usuarioweb";
    let nomid = "idusuarioweb";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idusuarioweb}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          txtLogin.current.value = "";
          txtNombreUsu.current.value = "";

          if (response.data !== "") {
            txtLogin.current.value = response.data.login;
            txtNombreUsu.current.value = response.data.nombre;
          } else {
            txtCodigoUsu.current.value = "";
            if (tecla === 13) {
              setTitulo("Error");
              setMsg("El Usuario no existe.");
            }
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const datosInmu = (idinmueble) => {
    let campos = "*";
    let nomtab = "inmueble";
    let nomid = "idinmueble";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idinmueble}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          txtNombrePropie.current.value = "";
          txtCodCatastroInm.current.value = "";

          if (response.data !== "") {
            txtNombrePropie.current.value = response.data.nombrepropie;
            txtCodCatastroInm.current.value = response.data.codigocatastral;

            txtNumRegistro.current.focus();
          } else {
            txtCodigoInm.current.value = "";
            if (tecla === 13) {
              setTitulo("Error");
              setMsg("El Inmueble no existe.");
            }
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const blanquear = () => {
    setRitm("")
    setIdComercio()
    setVisible(false);
    setOperacionPer(0);
    setEliminarActividadxComer();
    setTitulo("");
    setMsg("");
    setActivate(false);
    setTabs({
      class1: "nav-link active bg-blue-100 text-light rounded",
      select1: "true",
      content1: "tab-pane fade show active px-0",
      class2: "nav-link bg-blue-200 text-light rounded",
      select2: "false",
      content2: "tab-pane fade",
    });
  };

  const validarPersona = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setTecla(event.which);
        datosRes(event.target.value);
      } else {
        txtNombreRespon.current.value = "";
      }
    }
  };

  const validarInmueble = (event) => {
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        datosInmu(event.target.value);
      } else {
        txtNombrePropie.current.value = "";
        txtCodCatastroInm.current.value = "";
      }
    }
  };

  const handleCloseSi = () => {
    if (
      mensajesino.texto === "Esta seguro de Eliminar la Actividad por Comercio?"
    ) {
      var axc = records;
      var axc = axc.filter(function (axc) {
        return axc.idactividad !== eliminarActividadxComer;
      });
      setRecords(axc);
    } else if (mensajesino.texto === "Esta seguro de descartar la accion?") {
      setHabilitadoNR(false);
      blanquear();
      props.onHideCancela();
    }
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const handleCloseCatalogoInm = () => {
    setMostrar4(false);
  };

  const handleAceptaCatalogoInm = (idInmue, nomPropie, codCat) => {
    setMostrar4(false);
    txtCodigoInm.current.value = idInmue;
    txtNombrePropie.current.value = nomPropie;
    txtCodCatastroInm.current.value = codCat;
  };

  const handleCloseCatalogoPer = () => {
    setMostrar3(false);
  };

  const handleAceptaCatalogoPer = (
    cedPer,
    nomPer,
    apePer,
    correoPer,
    tlf1Per,
    tlf2Per,
    fnacPer,
    nacPer,
    sexoPer,
    direPer
  ) => {
    setMostrar3(false);
    txtCedula.current.value = cedPer;
    txtNombreRespon.current.value = nomPer;
    txtApellidoRespon.current.value = apePer;
    txtDireccionRespon.current.value = direPer;
    txtEmailRespon.current.value = correoPer;
    txtTlfRespon.current.value = tlf1Per;
    txtCelRespon.current.value = tlf2Per;
    txtFechaNac.current.value = moment.utc(fnacPer).format("YYYY-MM-DD");
    cmbNacionalidad.current.value = nacPer;
    cmbSexo.current.value = sexoPer;
    txtCodigoInm.current.focus();
  };

  const handleCloseCatalogoActi = () => {
    setMostrar2(false);
  };

  const handleAceptaCatalogoActi = (
    idActi,
    codciu,
    codacti,
    descrip,
    alicuo,
    mini
  ) => {
    if (cual === 0) {
      setMostrar2(false);
      setIdActividad(idActi);
      txtCodActividad.current.value = codciu;
      txtAlicuota.current.value = alicuo;
      txtDescripcionActi.current.value = descrip.trim();
      txtEmailContri.current.focus();
    } else {
      setMostrar2(false);
      var axc = records;
      var sigue = true;
      for (let i = 0; i < axc.length; i++) {
        if (axc[i].idactividad === idActi) {
          setTitulo("Información");
          setMsg("La Actividad está Duplicada.");
          sigue = false;
          break;
        }
      }
      if (sigue) {
        axc.push({
          alicuota: alicuo,
          codigoactividad: codacti,
          codigociu: codciu,
          descripcion: descrip.trim(),
          idactividad: idActi,
          minimo: mini,
        });
        setRecords(axc);
      }
    }
  };

  const handleCloseCatalogoUsuW = () => {
    setMostrar6(false);
  };

  const handleAceptaCatalogoUsuW = (login, nomUsuW, idUsuW) => {
    setMostrar6(false);
    txtCodigoUsu.current.value = idUsuW;
    txtLogin.current.value = login;
    txtNombreUsu.current.value = nomUsuW;
    txtCodigoUsu.current.focus();
  };

  const cancelar = (e) => {
    e.preventDefault();
    if (operacion !== 4) {
      setMensajesino({
        mostrar: true,
        titulo: "Notificación",
        texto: "Esta seguro de descartar la accion?",
        icono: "informacion",
      });
    } else {
      setHabilitadoNR(false);
      blanquear();
      props.onHideCancela();
    }
  };

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    var nanio = [];
    var aini = parseInt(obj.anioactu) - 7;
    var afin = parseInt(obj.anioactu);
    for (let i = 1; i <= afin - aini; i++) {
      nanio.push({ anio: aini + i });
    }
    setAnio(nanio);
    if (props.tabactixcomer) {
      setRecords(props.tabactixcomer);
    }
    if (op.reportes != null) {
    } else {
    }
    if (props.actividadcome) {
      setIdActividad(props.actividadcome.idactividad);
    }
  }, [
    props.tabactixcomer,
    props.comercio,
    props.actividadcome,
    props.operacion,
  ]);
  const handleInputChange = (event) => {
    if (event.which === 13) {
      var valido;
      if (event.target.id === "inputRitm") {
        //
        txtCodCatastro.current.focus();
      } else if (event.target.id === "inputRif") {
        txtDenominacionCome.current.focus();
      } else if (event.target.id === "inputCodigoCat") {
        txtNumLicencia.current.focus();
      } else if (event.target.id === "inputNumLicencia") {
        txtNumPatente.current.focus();
      } else if (event.target.id === "inputDenoComer") {
        txtTlfContri.current.focus();
      } else if (event.target.id === "inputSectorUrbano") {
        txtSectorCatastral.current.focus();
      } else if (event.target.id === "inputTlfContri") {
        valido = validaNumeroTelefono(event.target.value);
        if (valido) {
          txtDireccionContri.current.focus();
        }
      } else if (event.target.id === "inputTipoActividad") {
        txtEmailContri.current.focus();
      } else if (event.target.id === "inputCodActividad") {
      } else if (event.target.id === "inputEmailContri") {
        valido = validaEmail(event.target.value);
        if (valido) {
          if (visible) {
            txtCredito.current.focus();
          } else {
            txtCedula.current.focus();
          }
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "Información",
              texto: "Formato de Email invalido.",
              icono: "informacion",
            });

            event.target.value = "";
          } else {
            if (visible) {
              txtCredito.current.focus();
            } else {
              txtCedula.current.focus();
            }
          }
        }
      } else if (event.target.id === "inputNomResponsable") {
        txtApellidoRespon.current.focus();
      } else if (event.target.id === "inputApeResponsable") {
        txtDireccionRespon.current.focus();
      } else if (event.target.id === "inputEmailResponsable") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtTlfRespon.current.focus();
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "Información",
              texto: "Formato de Email invalido.",
              icono: "informacion",
            });
            event.target.value = "";
          } else {
            txtTlfRespon.current.focus();
          }
        }
      } else if (event.target.id === "inputTlfResponsable") {
        valido = validaNumeroTelefono(event.target.value);
        if (valido) {
          txtCelRespon.current.focus();
        } else {
          txtCelRespon.current.focus();
        }
      } else if (event.target.id === "inputCelResponsable") {
        valido = validaNumeroTelefono(event.target.value);
        if (valido) {
          txtFechaNac.current.focus();
        } else {
          txtFechaNac.current.focus();
        }
      } else if (event.target.id === "inputFechaNac") {
        cmbNacionalidad.current.focus();
      } else if (event.target.id === "inputNumRegistro") {
        txtFechaInscripcion.current.focus();
      } else if (event.target.id === "inputFechaInscripcion") {
        txtIslr.current.focus();
      } else if (event.target.id === "inputFechaInscripcionLic") {
        txtNumEmpleados.current.focus();
      } else if (event.target.id === "inputNumEmpleados") {
        txtNumTecnicos.current.focus();
      } else if (event.target.id === "inputNumTecnicos") {
        txtNumObreros.current.focus();
      } else if (event.target.id === "inputNumObreros") {
        txtTipoNegocio.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.id === "inputTlfContri") {
        valido = validaNumeroTelefono(event.target.value);
      } else if (event.target.id === "inputEmailContri") {
        valido = validaEmail(event.target.value);
        if (valido) {
          if (visible) {
            txtCredito.current.focus();
          } else {
            txtCedula.current.focus();
          }
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "Información",
              texto: "Formato de Email invalido.",
              icono: "informacion",
            });
            event.target.value = "";
          } else {
            if (visible) {
              txtCredito.current.focus();
            } else {
              txtCedula.current.focus();
            }
          }
        }
      } else if (event.target.id === "inputEmailResponsable") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtTlfRespon.current.focus();
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "Información",
              texto: "Formato de Email invalido.",
              icono: "informacion",
            });
            event.target.value = "";
          } else {
            txtTlfRespon.current.focus();
          }
        }
      } else if (event.target.id === "inputTlfResponsable") {
        valido = validaNumeroTelefono(event.target.value);
        if (valido) {
          txtCelRespon.current.focus();
        } else {
          txtCelRespon.current.focus();
        }
      } else if (event.target.id === "inputCelResponsable") {
        valido = validaNumeroTelefono(event.target.value);
        if (valido) {
          txtFechaNac.current.focus();
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "Información",
              texto: "Formato de número telefonico invalido.",
              icono: "informacion",
            });
            event.target.value = "";
          } else {
            txtFechaNac.current.focus();
          }
        }
      } else {
        return false;
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which >= 37 && event.which <= 40) {
      event.preventDefault();
    }
    if (event.target.value) {
      let e = event.target.value
        .replace(/\D/g, "")
        .replace(/([0-9])([0-9]{2})$/, "$1.$2")
        .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");

      return formatMoneda(e);
    } else if (event.target.value === "0") {
      return "0,00";
    } else {
      return "0,00";
    }
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    console.log(coordenadas)

    if (cmbRif.current.value === "0") {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto:
          "Por Favor Indique el Tipo de Persona en el Registro de Información Fiscal (RIF).",
        icono: "error",
      });

      sigue = false;
      cmbRif.current.focus();
    } else if (txtRif.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto:
          "El Numero de Registro de Información Fiscal (RIF) no debe estar vacio.",
        icono: "error",
      });
      txtRif.current.focus();
      sigue = false;
    } else if (txtDenominacionCome.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "La Denominación Comercial no debe estar vacia.",
        icono: "error",
      });
      sigue = false;
      txtDenominacionCome.current.focus();
    } else if (txtDireccionContri.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "La Dirección de la Empresa no debe estar vacia.",
        icono: "error",
      });
      sigue = false;
      txtDireccionContri.current.focus();
    } else if (txtSectorUrbano.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "El Campo Sector Urbano no debe estar vacio.",
        icono: "error",
      });
      sigue = false;
      txtSectorUrbano.current.focus();
    } else if (txtSectorCatastral.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "El Campo Sector Catastral no debe estar vacio.",
        icono: "error",
      });
      sigue = false;
      txtSectorCatastral.current.focus();
    } else if (txtTlfContri.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Debe Introducir el Nº de Telefono de la Empresa.",
        icono: "error",
      });
      sigue = false;
      txtTlfContri.current.focus();
    } else if (txtNumRegistro.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Debe Introducir el Nº de Registro de Comercio de la Empresa.",
        icono: "error",
      });
      setTabs({
        class2: "nav-link active bg-blue-200 text-light rounded",
        select2: "true",
        content2: "tab-pane fade show active",
        class1: "nav-link bg-blue-100 text-light rounded",
        select1: "false",
        content1: "tab-pane fade px-0",
      });
      sigue = false;
      txtNumRegistro.current.focus();
    } else if (txtFechaInscripcion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Debe Introducir la Fecha de Inscripción de la Empresa.",
        icono: "error",
      });
      setTabs({
        class2: "nav-link active bg-blue-200 text-light rounded",
        select2: "true",
        content2: "tab-pane fade show active",
        class1: "nav-link bg-blue-100 text-light rounded",
        select1: "false",
        content1: "tab-pane fade px-0",
      });
      sigue = false;
      txtFechaInscripcion.current.focus();
    } else if (cmbTipCont.current.value < 0) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Debe Seleccionar el Tipo de Contribuyente.",
        icono: "error",
      });
      setTabs({
        class2: "nav-link active bg-blue-200 text-light rounded",
        select2: "true",
        content2: "tab-pane fade show active",
        class1: "nav-link bg-blue-100 text-light rounded",
        select1: "false",
        content1: "tab-pane fade px-0",
      });
      sigue = false;
      cmbTipCont.current.focus();
    // } else if (coordenadas.latitud === null || coordenadas.longitud === null) {
    //   setMensaje({
    //     mostrar: true,
    //     titulo: "Error",
    //     texto: "Debe Ingresar la Ubicación del Contribuyente.",
    //     icono: "error",
    //   });
    //   setTabs({
    //     class2: "nav-link active bg-blue-200 text-light rounded",
    //     select2: "true",
    //     content2: "tab-pane fade show active",
    //     class1: "nav-link bg-blue-100 text-light rounded",
    //     select1: "false",
    //     content1: "tab-pane fade px-0",
    //   });
    //   sigue = false;
    //   cmbTipCont.current.focus();
    } else if (cmbClaseCont.current.value < 0) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Debe Seleccionar la Clase de Contribuyente.",
        icono: "error",
      });
      setTabs({
        class2: "nav-link active bg-blue-200 text-light rounded",
        select2: "true",
        content2: "tab-pane fade show active",
        class1: "nav-link bg-blue-100 text-light rounded",
        select1: "false",
        content1: "tab-pane fade px-0",
      });
      sigue = false;
      cmbClaseCont.current.focus();
    } else if (txtFechaEmisionPate.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Debe Introducir la Fecha Valida de la Patente.",
        icono: "error",
      });
      setTabs({
        class2: "nav-link active bg-blue-200 text-light rounded",
        select2: "true",
        content2: "tab-pane fade show active",
        class1: "nav-link bg-blue-100 text-light rounded",
        select1: "false",
        content1: "tab-pane fade px-0",
      });
      sigue = false;
      txtFechaEmisionPate.current.focus();
    } else if (txtIslr.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Debe Introducir el Porcentaje de Retención del I.S.L.R.",
        icono: "error",
      });
      setTabs({
        class2: "nav-link active bg-blue-200 text-light rounded",
        select2: "true",
        content2: "tab-pane fade show active",
        class1: "nav-link bg-blue-100 text-light rounded",
        select1: "false",
        content1: "tab-pane fade px-0",
      });
      sigue = false;
      txtIslr.current.focus();
    } else if (txtCapPag.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Debe Introducir el Capital Pagado.",
        icono: "error",
      });
      setTabs({
        class2: "nav-link active bg-blue-200 text-light rounded",
        select2: "true",
        content2: "tab-pane fade show active",
        class1: "nav-link bg-blue-100 text-light rounded",
        select1: "false",
        content1: "tab-pane fade px-0",
      });
      sigue = false;
      txtCapPag.current.focus();
    } else if (txtCapSub.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Debe Introducir el Capital Subscrito.",
        icono: "error",
      });
      setTabs({
        class2: "nav-link active bg-blue-200 text-light rounded",
        select2: "true",
        content2: "tab-pane fade show active",
        class1: "nav-link bg-blue-100 text-light rounded",
        select1: "false",
        content1: "tab-pane fade px-0",
      });

      sigue = false;
      txtCapSub.current.focus();
    } else if (
      !cmbStatus.current.value.trim() === "ACTIVO" &&
      txtObserStatus.current.value.trim() === ""
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Debe Introducir una Observación del Status.",
        icono: "error",
      });
      setTabs({
        class2: "nav-link active bg-blue-200 text-light rounded",
        select2: "true",
        content2: "tab-pane fade show active",
        class1: "nav-link bg-blue-100 text-light rounded",
        select1: "false",
        content1: "tab-pane fade px-0",
      });

      sigue = false;
      txtObserStatus.current.focus();
    } else if (txtCedula.current.value.trim() === "" && operacion !== 3) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "La cedula no debe estar vacia.",
        icono: "error",
      });
      sigue = false;
      txtCedula.current.focus();
    } else if (txtNombreRespon.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Los nombres no deben estar vacios.",
        icono: "error",
      });
      sigue = false;
      txtNombreRespon.current.focus();
    } else if (txtApellidoRespon.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Los Apellidos no deben estar vacio.",
        icono: "error",
      });
      sigue = false;
      txtApellidoRespon.current.focus();
    } else if (txtFechaNac.current.value.trim() === "" && operacionPer === 1) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "La fecha de nacimiento no debe estar vacia.",
        icono: "error",
      });
      sigue = false;
      txtFechaNac.current.focus();
    }

    if (sigue) {
      var comer = [];
      var actixcomer = [];
      var reprel = [];
      comer.push({
        longitud: coordenadas.longitud ? coordenadas.longitud : 0,
        latitud: coordenadas.latitud ? coordenadas.latitud : 0,
        actualizado: txtEmailContri.current.value === "" ? false : true,
        acreditacion: chkAcreditacion.current.checked,
        aniopridecla: cmbAnio.current.value,
        capitalpagado: txtCapPag.current.value
          .trim()
          .replace(/\./g, "")
          .replace(",", "."),
        capitalsuscrito: txtCapSub.current.value
          .trim()
          .replace(/\./g, "")
          .replace(",", "."),
        clasecontribuyente: cmbClaseCont.current.value,
        codigocatastral: 0,
        codigopatente: 0,
        convenio: chkConvenio.current.checked,
        credito: txtCredito.current.value
          .trim()
          .replace(/\./g, "")
          .replace(",", "."),
        declara: radioDeclaraSi.current.checked ? 1 : 0,
        direccion: txtDireccionContri.current.value.trim(),
        email: txtEmailContri.current.value,
        esagentereten: chkAgente.current.checked,
        exonintereses: chkExonIntereses.current.checked,
        exonmultas: chkExonMultas.current.checked,
        exonrecargos: chkExonRecargos.current.checked,
        fechaemisionpate: txtFechaEmisionPate.current.value,
        fechainscripcion: txtFechaInscripcion.current.value,
        fechainscripcionlicores: txtFechaInscripcionlic.current.value,
        idactividad: idActividad ? idActividad : 1,
        idcomercio:idComercio,
        idinmueble: txtCodigoInm.current.value,
        mespridecla: cmbMes.current.value,
        montodeclarado: 0.0,
        montopatente: 0.0,
        nombre: txtDenominacionCome.current.value.trim(),
        numempleados: txtNumEmpleados.current.value,
        numerolicencia: txtNumLicencia.current.value,
        numobreros: txtNumObreros.current.value,
        numregistro: txtNumRegistro.current.value,
        numtecnicos: txtNumTecnicos.current.value,
        observacionstatus: txtObserStatus.current.value,
        porcentajeretencion: txtIslr.current.value
          .trim()
          .replace(/\./g, "")
          .replace(",", "."),
        recactaconstitutiva: chkRecActaConstitutiva.current.checked,
        recbalacecomprobacion: chkRecBalaceComprobacion.current.checked,
        recbalaceganancias: chkRecBalaceGanancias.current.checked,
        recbalacegeneral: chkRecBalaceGeneral.current.checked,
        reccedularep: chkRecCedulaRep.current.checked,
        recdeclaracionisrl: chkRecDeclaracionIsrl.current.checked,
        recregcomercio: chkRecRegComercio.current.checked,
        recrif: chkRecRif.current.checked,
        recsolvenciamunicipal: chkRecSolvenciaMunicipal.current.checked,
        reprelegal: txtCedula.current.value,
        rif: cmbRif.current.value + txtRif.current.value,
        ritm: ritm ? ritm : '',
        sectorcatastral: txtSectorCatastral.current.value,
        sectorurbano: txtSectorUrbano.current.value,
        status: cmbStatus.current.value !== '' ? cmbStatus.current.value : 51,
        telefono: txtTlfContri.current.value,
        tipoactividad: 0,
        tipocontribuyente: cmbTipCont.current.value,
        tiponegocio: txtTipoNegocio.current.value,
      });
      reprel.push({
        apellidos: txtApellidoRespon.current.value.trim(),
        cedula: txtCedula.current.value,
        correoe: txtEmailRespon.current.value,
        direccion: txtDireccionRespon.current.value.trim(),
        fnacimiento: txtFechaNac.current.value,
        nacionalidad: cmbNacionalidad.current.value,
        nombres: txtNombreRespon.current.value.trim(),
        sexo: cmbSexo.current.value,
        tlf1: txtTlfRespon.current.value,
        tlf2: txtCelRespon.current.value,
      });
      actixcomer = records;
      setActivate(true);
      let body = {
        operacion: operacion,
        operacionper: operacionPer,
        declaweb: declaWeb,
        fechasis: fechaSistema,
        ingresa: props.ingresa,
        idusu: idUsuario,
        come: JSON.stringify(comer),
        repre: JSON.stringify(reprel),
        actixcome: JSON.stringify(actixcomer),
      };
      procesarRegistro(body);
    } else {
    }
  };

  const catalogoPer = (e) => {
    e.preventDefault();
    if (operacion < 3) {
      setMostrar3(true);
    }
  };

  const catalogoActi = (cualCat) => (e) => {
    e.preventDefault();
    setCual(cualCat);
    if (operacion < 3) {
      setMostrar2(true);
    }
  };

  const catalogoInm = (e) => {
    e.preventDefault();
    if (operacion < 3) {
      setMostrar4(true);
    }
  };

  const handlerClickTab = (index) => {
    if (operacion === 1 && (index === 2 || index === 3)) {
    } else {
    }
  };

  const eliminarActividad = (id) => (event) => {
    setMensajesino({
      mostrar: true,
      titulo: "Notificación",
      texto: "Esta seguro de Eliminar la Actividad por Comercio?",
      icono: "informacion",
    });
    setEliminarActividadxComer(id);
  };

  const onChange = (e) => {
    if (
      e.target.id === "inputDenoComer" ||
      e.target.id === "inputDireccionContri" ||
      e.target.id === "inputTipoActividad" ||
      e.target.id === "inputSectorUrbano" ||
      e.target.id === "inputSectorCatastral"
    ) {
      e.target.value = e.target.value.toUpperCase();
    }
  };

  const validarCapcha = () => {
    var valido = ValidCaptcha();
    if (valido) {
      setMostrar7(false);
      setTitulo("Corfirmar");
      if (operacion === 1) {
        setMsg("Esta seguro de registrar el contibuyente con estos datos?");
      } else if (operacion === 2) {
        setMsg("Esta seguro de modificar el contibuyente con estos datos?");
      } else if (operacion === 3) {
        setMsg("Esta seguro de eliminar el contibuyente?");
      }
    }
  };

  const handleCancelaCapcha = () => {
    setMostrar7(false);
  };

  const cerrarModal = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });

    props.onHideCancela();
  };

  const controlTab = () => (e) => {
    if (e.target.id === "datosTributarios") {
      setTabs({
        class1: "nav-link active bg-blue-100 text-light rounded",
        select1: "true",
        content1: "tab-pane fade show active px-0",
        class2: "nav-link bg-blue-200 text-light rounded",
        select2: "false",
        content2: "tab-pane fade",
      });
    } else {
      setTabs({
        class2: "nav-link active bg-blue-200 text-light rounded",
        select2: "true",
        content2: "tab-pane fade show active",
        class1: "nav-link bg-blue-100 text-light rounded",
        select1: "false",
        content: "tab-pane fade px-0",
      });
    }
  };
  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
         

        if (props.comercio) {
          setIdComercio(props.comercio.idcomercio)
          setRitm(props.comercio.ritm)
        }
        setCoordenadas({
            latitud: props.comercio ? props.comercio.latitud : 0,
            longitud: props.comercio ? props.comercio.longitud : 0
          })
        setFactorCambio(props.factorCambio);
        if (props.operacion === 1 && contar1 === 0 && anio.length > 0) {
          cmbAnio.current.value = anio[anio.length - 1].anio;
          setContar1(1);
        }
        setVisible(false);
        setOperacion(props.operacion);
        // props.operacion < 3
        //   ? txtRitm.current.focus()
        //   : btnAcepta.current.focus();
        if (props.ingresa > 0) {
          setOperacionPer(props.operacionper);
          if (props.operacionper === 0) {
            setHabilitadoNR(false);
          } else {
            setHabilitadoNR(true);
          }
        } else {
          setOperacionPer(0);
          setHabilitadoNR(false);
        }
         if (props?.licencia) {
          setHabilitadoNR(true)
        }
        setDeshabilitado(props.deshabilitado);
        setOperacion(props.operacion);
        setIdUsuario(props.idusuario);
        setDeclaWeb(Boolean(props.declaweb));
        setRecords(props.tabactixcomer ? props.tabactixcomer : []);
        setContar1(0);
      }}
    >
      <Modal.Header className="azulGradiant modal-header">
        {operacion === 1
          ? "Agregar Contribuyente. - Actividad Economica."
          : operacion === 2
            ? "Editar Contribuyente. - Actividad Economica."
            : operacion === 3
              ? "Eliminar Contribuyente. - Actividad Economica."
              : "Consultar Contribuyente. - Actividad Economica."}

        <div className="input-group input-group-sm col-md-2 mr-0 my-auto">
          <span className="input-group-text bg-transparent fw-bold border-0 text-light">
            Valor Euro €:
          </span>
          <span className="input-group-text bg-transparent fw-bold border-0  text-light">
            {formatMoneda(
              factorCambio.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2
            )}
          </span>
        </div>
        <button
          ref={btnCancela}
          className="btn"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="tipo-letra" style={{ height: "auto" }}>
          <ul className="nav d-flex flex-wrap gap-1 align-items-center" id="ex-with-icons" role="tablist">
            <li className="nav-item " role="presentation">
              <a
                onClick={controlTab}
                className={tabs.class1}
                id="datosTributarios"
                data-bs-toggle="tab"
                type="button"
                data-bs-target="#tributarios"
                role="tab"
                aria-controls="tributarios"
                aria-selected={tabs.select1}
              >
                Datos Generales
              </a>
            </li>
            <li className="nav-item " role="presentation">
              <a
                onClick={controlTab}
                className={tabs.class2}
                id="deuda-tab"
                data-bs-toggle="tab"
                type="button"
                data-bs-target="#deuda"
                role="tab"
                aria-controls="deuda"
                aria-selected={tabs.select2}
              >
                Otros Datos
              </a>
            </li>
            <li className="nav-item " role="localización">
              <a
                onClick={controlTab}
                className="nav-link bg-blue-300 text-light rounded"
                id="local-tab"
                data-bs-toggle="tab"
                type="button"
                data-bs-target="#local"
                role="tab"
                aria-controls="local"
                aria-selected="false"
              >
                Datos de Localización
              </a>
            </li>
            <li className="nav-item " role="presentation">
              <a
                className="nav-link bg-blue-300 text-light rounded"
                disabled={operacion === 1 ? true : false}
                id="hist-tab"
                data-bs-toggle="tab"
                type="button"
                data-bs-target="#historico"
                role="tab"
                aria-controls="historico"
                aria-selected="false"
              >
                Deudas Contribuyente
              </a>
            </li>
            <li className="nav-item " role="presentation">
              <a
                className="nav-link bg-blue-400 text-light rounded"
                disabled={operacion === 1 ? true : false}
                id="multas-tab"
                data-bs-toggle="tab"
                type="button"
                data-bs-target="#multas"
                role="tab"
                aria-controls="multas"
                aria-selected="false"
              >
                Historico Pagos
              </a>
            </li>
            <li className="nav-item " role="presentation">
              <a
                className="nav-link bg-blue-600 text-light rounded"
                disabled={operacion === 1 ? true : false}
                id="pagoweb"
                data-bs-toggle="tab"
                type="button"
                data-bs-target="#tabs6"
                role="tab"
                aria-controls="tabs6"
                aria-selected="false"
              >
                Relación Pagos Web
              </a>
            </li>
            {props.comercio && props.comercio.esagentereten &&
              <li className="nav-item " role="presentation">
                <a
                  className="nav-link bg-blue-700 text-light rounded"
                  disabled={operacion === 1 ? true : false}
                  id="retenciones"
                  data-bs-toggle="tab"
                  type="button"
                  data-bs-target="#tabs7"
                  role="tab"
                  aria-controls="retenciones"
                  aria-selected="false"
                >
                  Historico Pago Retenciones
                </a>
              </li>
            }
            <li className="nav-item " role="presentation">
              <a
                className="nav-link bg-blue-800 text-light rounded"
                disabled={operacion === 1 ? true : false}
                id="dm"
                data-bs-toggle="tab"
                type="button"
                data-bs-target="#tabs8"
                role="tab"
                aria-controls="dm"
                aria-selected="false"
              >
                Deuda Multas
              </a>
            </li>
            <li className="nav-item " role="presentation">
              <a
                className="rounded nav-link bg-blue-900 text-light"
                id="factpag-tab"
                data-bs-toggle="tab"
                data-bs-target="#factpag"
                type="button"
                role="tab"
                aria-controls="factpag"
                aria-selected="false"
              >
                Relación Fact. Pagadas
              </a>
            </li>
            {parseInt(espiritu) === 11 &&
              <li className="nav-item " role="presentation">
                <a
                  className="rounded nav-link bg-blue-900 text-light"
                  id="factpag-tab2"
                  data-bs-toggle="tab"
                  data-bs-target="#factpag2"
                  type="button"
                  role="tab"
                  aria-controls="factpag2"
                  aria-selected="false"
                >
                  Declaraciones Etax.
                </a>
              </li>
            }
            {parseInt(espiritu) === 11 &&
              <li className="nav-item " role="presentation">
                <a
                  className="rounded nav-link bg-blue-900 text-light"
                  id="factpag-tab3"
                  data-bs-toggle="tab"
                  data-bs-target="#factpag3"
                  type="button"
                  role="tab"
                  aria-controls="factpag3"
                  aria-selected="false"
                >
                  Otros Pagos Etax.
                </a>
              </li>
            }
          </ul>
          <div className="tab-content" id="myTabContent">
            <div
              className={tabs.content1}
              id="tributarios"
              role="tabpanel"
              aria-labelledby="datosTributarios"
              onSelect={handlerClickTab}
              onDoubleClick={() => {
                if (operacion === 2) {
                  setVisible(true);
                }
              }}
            >
              <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
                <legend className="float-none w-auto m-0">
                  Datos del Contribuyente
                </legend>
                <div className="col-6 col-lg-3 col-xl-2 m-0 mb-2 p-0">
                  <Input
                    label="Código:"
                    disabled
                   
                    id="inputCodigo"
                    value={idComercio}
                  />
                </div>
                <div className="col-6 col-lg-3 col-xl-2 m-0 mb-2 p-0 pl-2">
                  <Input
                    label="Nº de RITM:"
                    disabled
                    id="inputRitm"
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                    value={ritm}
                  />
                </div>
                <div className="col-6 col-lg-3 col-xl-2 m-0 mb-2 p-0 pl-lg-2 d-flex">
                  {/* TODO */}
                  <div className="col-6 m-0 p-0">
                    <Select
                      label="RIF:"
                      disabled={deshabilitado}
                      id="inputLetraRif"
                      defaultValue={
                        props.comercio &&
                          isNaN(props.comercio.rif.substring(0, 1))
                          ? props.comercio.rif.substring(0, 1)
                          : ""
                      }
                      ref={cmbRif}
                    >
                      <option value="J">J</option>
                      <option value="V">V</option>
                      <option value="G">G</option>
                      <option value="E">E</option>
                      <option value="P">P</option>
                    </Select>
                  </div>
                  <Input
                    disabled={deshabilitado}
                    maxLength={14}
                    placeholder="123456789"
                    id="inputRif"
                    defaultValue={
                      props.comercio &&
                        isNaN(props.comercio.rif.substring(0, 1))
                        ? props.comercio.rif.substring(
                          1,
                          props.comercio.rif.trim().length
                        )
                        : props.comercio &&
                          !isNaN(props.comercio.rif.substring(0, 1))
                          ? props.comercio.rif.substring(
                            0,
                            props.comercio.rif.trim().length
                          )
                          : ""
                    }
                    ref={txtRif}
                  />
                </div>
                <div className="col-6 col-lg-3 col-xl-2 m-0 mb-2 p-0 pl-2">
                  <Input
                    label="Licencia:"
                    disabled={deshabilitado}
                    ref={txtNumLicencia}
                    defaultValue={
                      props.comercio && props.comercio.numerolicencia
                        ? props.comercio.numerolicencia !== null
                          ? props.comercio.numerolicencia.trim()
                          : ""
                        : ""
                    }
                    id="inputNumLicencia"
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </div>
                <div className="col-6 col-lg-3 col-xl-2 m-0 mb-2 p-0 pl-xl-2">
                  <Input
                    label="Teléfono:"
                    disabled={deshabilitado}
                    id="inputTlfContri"
                    placeholder="0000-0000000"
                    defaultValue={
                      props.comercio && props.comercio.telefono
                        ? props.comercio.telefono !== null
                          ? props.comercio.telefono.trim()
                          : ""
                        : ""
                    }
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                    ref={txtTlfContri}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Input
                    label="Denominación Comercial:"
                    type="text"
                    disabled={deshabilitado}
                    ref={txtDenominacionCome}
                    className="form-control form-control-sm"
                    defaultValue={
                      props.comercio ? props.comercio.nombre.trim() : ""
                    }
                    id="inputDenoComer"
                    name="denocomercial"
                    onChange={onChange}
                    onKeyUp={handleInputChange}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Textarea
                    label="Dirección:"
                    style={{ height: 70 }}
                    disabled={deshabilitado}
                    id="inputDireccionContri"
                    name="direc"
                    onChange={onChange}
                    rows={2}
                    defaultValue={
                      props.comercio
                        ? props.comercio.direccion !== null
                          ? props.comercio.direccion.trim()
                          : ""
                        : ""
                    }
                    onKeyUp={handleInputChange}
                    ref={txtDireccionContri}
                  />
                </div>
                <div className="col-6 col-lg-3 m-0 p-0">
                  <Input
                    label="Sector Urbano:"
                    disabled={deshabilitado}
                    ref={txtSectorUrbano}
                    id="inputSectorUrbano"
                    onChange={onChange}
                    defaultValue={
                      props.comercio && props.comercio.sectorurbano
                        ? props.comercio.sectorurbano !== null
                          ? props.comercio.sectorurbano.trim()
                          : ""
                        : ""
                    }
                    onKeyUp={handleInputChange}
                  />
                </div>
                <div className="col-6 col-lg-3 m-0 p-0 pl-2">
                  <Input
                    label="Sector Catastral:"
                    disabled={deshabilitado}
                    id="inputSectorCatastral"
                    onChange={onChange}
                    maxLength={8}
                    defaultValue={
                      props.comercio && props.comercio.sectorcatastral
                        ? props.comercio.sectorcatastral !== null
                          ? props.comercio.sectorcatastral.trim()
                          : ""
                        : ""
                    }
                    onKeyUp={handleInputChange}
                    ref={txtSectorCatastral}
                  />
                </div>
                <div className="col-6 col-lg-3 m-0 mt-2 mt-lg-0 p-0 pl-lg-2">
                  <Input
                    label="Email:"
                    disabled={deshabilitado}
                    id="inputEmailContri"
                    name="email"
                    onChange={onChange}
                    defaultValue={
                      props.comercio && props.comercio.email
                        ? props.comercio.email !== null
                          ? props.comercio.email.trim()
                          : ""
                        : ""
                    }
                    onKeyUp={handleInputChange}
                    ref={txtEmailContri}
                  />
                </div>
                <div className={!visible ? "d-none" : "col-3 m-0 p-0 pl-2"}>
                  <Input
                    label="Crédito:"
                    // hidden={!visible}
                    defaultValue={
                      props.comercio && props.comercio.credito
                        ? props.comercio.credito !== null
                          ? formatMoneda(
                            props.comercio.credito
                              .replace(",", "")
                              .replace(".", ","),
                            ",",
                            ".",
                            2
                          )
                          : "0,00"
                        : "0,00"
                    }
                    onFocus={seleccionarCampo}
                    onKeyUp={handleInputMontoChange}
                    onBlur={handleInputMontoChange}
                    ref={txtCredito}
                  />
                </div>
              </fieldset>
              <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
                <legend className="float-none w-auto m-0">
                  Datos del Responsable
                </legend>
                <div className="col-12 m-0 mb-2 p-0">
                  <div className="col-6 col-lg-4 col-xl-3 m-0 p-0 d-flex">
                    <Select
                      label="Cédula:"
                      name=""
                      disabled={!habilitadoNR}
                      defaultValue={
                        props.representante
                          ? props.representante.nacionalidad
                          : ""
                      }
                      ref={cmbNacionalidad}
                    >
                      <option key="0" value="V">
                        V
                      </option>
                      <option key="1" value="E">
                        E
                      </option>
                    </Select>
                    <SearchInput
                      disabled={deshabilitado}
                      id="inputCedula"
                      defaultValue={
                        props.representante ? props.representante.cedula : ""
                      }
                      onKeyUp={validarPersona}
                      onBlur={validarPersona}
                      ref={txtCedula}
                      onClickButton={catalogoPer}
                      disabledButton={deshabilitado}
                    />
                  </div>
                </div>
                <div className="col-12 col-lg-6 m-0 mb-2 p-0">
                  <Input
                    label="Nombres:"
                    disabled={!habilitadoNR}
                    id="inputNomResponsable"
                    defaultValue={
                      props.representante && props.representante.nombres
                        ? props.representante.nombres.trim()
                        : ""
                    }
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                    ref={txtNombreRespon}
                  />
                </div>
                <div className="col-12 col-lg-6 m-0 mb-2 p-0 pl-lg-2">
                  <Input
                    label="Apellidos:"
                    disabled={!habilitadoNR}
                    id="inputApeResponsable"
                    defaultValue={
                      props.representante && props.representante.apellidos
                        ? props.representante.apellidos.trim()
                        : ""
                    }
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                    ref={txtApellidoRespon}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Textarea
                    label="Dirección:"
                    style={{ height: 70 }}
                    disabled={!habilitadoNR}
                    id="inputDireResponsable"
                    defaultValue={
                      props.representante && props.representante.direccion
                        ? props.representante.direccion.trim()
                        : ""
                    }
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                    ref={txtDireccionRespon}
                  />
                </div>
                <div className="col-6 col-lg-3 m-0 mb-2 p-0">
                  <Input
                    label="Email:"
                    disabled={!habilitadoNR}
                    id="inputEmailResponsable"
                    defaultValue={
                      props.representante
                        ? props.representante.correoe !== null && 
                        props.representante.correoe !== undefined
                          ? props.representante.correoe.trim()
                          : ""
                        : ""
                    }
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                    ref={txtEmailRespon}
                  />
                </div>
                <div className="col-6 col-lg-3 m-0 mb-2 p-0 pl-2">
                  <Input
                    label="Teléfono:"
                    disabled={!habilitadoNR}
                    id="inputTlfResponsable"
                    placeholder="0000-0000000"
                    defaultValue={
                      props.representante
                        ? props.representante.tlf1 !== null &&
                        props.representante.tlf1 !== undefined
                          ? props.representante.tlf1.trim()
                          : ""
                        : ""
                    }
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                    ref={txtTlfRespon}
                  />
                </div>
                <div className="col-6 col-lg-3 m-0 mb-2 p-0 pl-lg-2">
                  <Input
                    label="Célular:"
                    disabled={!habilitadoNR}
                    id="inputCelResponsable"
                    placeholder="0000-0000000"
                    defaultValue={
                      props.representante
                        ? props.representante.tlf2 !== null && 
                        props.representante.tlf2 !== undefined
                          ? props.representante.tlf2.trim()
                          : ""
                        : ""
                    }
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                    ref={txtCelRespon}
                  />
                </div>
                <div className="col-6 col-lg-3 m-0 mb-2 p-0 pl-2">
                  <Select
                    label="Sexo:"
                    name=""
                    disabled={!habilitadoNR}
                    defaultValue={
                      props.representante ? props.representante.sexo : ""
                    }
                    ref={cmbSexo}
                  >
                    <option key="0" value="M">
                      M
                    </option>
                    <option key="1" value="F">
                      F
                    </option>
                  </Select>
                </div>
                <div className="col-7 col-lg-4 col-xl-3 m-0 p-0">
                  <Input
                    label="Fecha de Nacimiento:"
                    type="date"
                    disabled={!habilitadoNR}
                    id="inputFechaNac"
                    max={fechaSistema}
                    defaultValue={
                      props.representante
                        ? moment.utc(props.representante.fnacimiento).format(
                          "YYYY-MM-DD"
                        )
                        : ""
                    }
                    onKeyUp={handleInputChange}
                    ref={txtFechaNac}
                  />
                </div>
              </fieldset>
              <fieldset className='col-12 m-0 p-2 d-flex gap-2 border-azul rounded'>
                  <legend className="float-none w-auto m-0">
                    Actividades Asignadas para Declarar
                  </legend>
                  <div className="p-0 col-md-11 mx-auto row">
                    <TblContainer
                      container={{
                        height: 150,
                        width: "100%",
                        overflow: "auto",
                        padding: "2px",
                      }}
                    >
                      <TblHead />
                      <tbody>
                        {records &&
                          recordsAfterPagingAndSorting().map(
                            (item, index) => (
                              <tr
                                key={item.idactividad}
                                style={{ padding: "0" }}
                              >
                                <td
                                  style={{
                                    fontSize: "10px",
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                    minWidth: "120px",
                                  }}
                                >
                                  {item.codigoactividad.trim()}
                                </td>
                                <td
                                  style={{
                                    fontSize: "10px",
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                    minWidth: "120px",
                                  }}
                                >
                                  {item.codigociu.trim()}
                                </td>
                                <td
                                  style={{
                                    fontSize: "10px",
                                    textAlign: "left",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {item.descripcion.trim()}
                                </td>
                                <td
                                  style={{
                                    fontSize: "10px",
                                    textAlign: "right",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {formatMoneda(
                                    item.alicuota
                                      .toString()
                                      .replace(".", ","),
                                    ",",
                                    ".",
                                    2
                                  )}
                                </td>
                                <td
                                  style={{
                                    fontSize: "10px",
                                    textAlign: "right",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {formatMoneda(
                                    item.minimo
                                      .toString()
                                      .replace(".", ","),
                                    ",",
                                    ".",
                                    2
                                  )}
                                </td>
                                <td
                                  align="center"
                                  style={{
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  <button
                                    disabled={
                                      operacion === 2 || operacion === 1 ? false : true
                                    }
                                    onClick={eliminarActividad(
                                      item.idactividad,
                                      index
                                    )}
                                    className="btn btn-sm btn-danger rounded-circle my-auto"
                                  >
                                    <i className="fa fa-trash-alt"></i>
                                  </button>
                                </td>
                              </tr>
                            )
                          )}
                      </tbody>
                    </TblContainer>
                  </div>
                  <div className="col-1 m-0 p-0 d-flex justify-content-center align-items-center">
                    <PrimaryButton icon="fa fa-plus m-0"
                      onClick={catalogoActi(1)}
                      disabled={operacion === 2 || operacion === 1 ? false : true}
                    />
                  </div>
                </fieldset>
              <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
                <legend className="float-none w-auto m-0">
                  Datos del Inmueble
                </legend>
                <div className="col-6 col-lg-3 m-0 mb-2 mb-xl-0 p-0">
                  <SearchInput label="Código:"
                    disabled={deshabilitado}
                    id="inputCodigoInm"
                    defaultValue={
                      props.inmueble && props.inmueble[0] ? props.inmueble[0].idinmueble : ""
                    }
                    onKeyUp={validarInmueble}
                    onBlur={validarInmueble}
                    onClickButton={catalogoInm}
                    disabledButton={deshabilitado}
                    ref={txtCodigoInm}
                  />
                </div>
                <div className="col-12 col-lg-9 col-xl-6 m-0 mb-2 mb-xl-0 p-0 pl-lg-2">
                  <Input label="Nombre del Propietario:"
                    disabled={true}
                    id="inputNomResponsable"
                    defaultValue={
                      props.inmueble && props.inmueble[0]
                        ? props.inmueble[0].nombrepropie.trim()
                        : ""
                    }
                    ref={txtNombrePropie}
                  />
                </div>
                <div className="col-6 col-lg-4 col-xl-3 m-0 p-0 pl-xl-2">
                  <Input label="Codigo Catastral:"
                    disabled={true}
                    id="inputApeResponsable"
                    defaultValue={
                      props.inmueble && props.inmueble[0]
                        ? props.inmueble[0].codigocatastral.trim()
                        : ""
                    }
                    ref={txtCodCatastroInm}
                  />
                </div>
              </fieldset>
            </div>
            <div
              className={tabs.content2 + ' col-12 m-0 p-0'}
              id="deuda"
              role="tabpanel"
              aria-labelledby="deuda-tab"
            >
              <div className="col-12 m-0 mt-2 p-0 d-flex flex-wrap">
                <div className="col-12 col-lg-8 m-0 p-0 pr-2 d-flex flex-wrap">
                  <div className="col-12 col-lg-12 col-xl-8 m-0 mb-2 mb-xl-0 p-0">
                    <Input label="Nº de Registro de Comercio:"
                      disabled={deshabilitado}
                      ref={txtNumRegistro}
                      id="inputNumRegistro"
                      defaultValue={
                        props.comercio && props.comercio.numregistro
                          ? props.comercio.numregistro !== null
                            ? props.comercio.numregistro.trim()
                            : 0
                          : 0
                      }
                      onKeyUp={handleInputChange}
                    />
                  </div>
                  <div className="col-6 col-lg-6 col-xl-4 m-0 mb-2 p-0 pl-xl-2">
                    <Input label="Fecha Inscripción:"
                      type="date"
                      disabled={deshabilitado}
                      id="inputFechaInscripcion"
                      max={fechaSistema}
                      defaultValue={
                        props.comercio
                          ? props.comercio.fechainscripcion !== null
                            ? moment.utc(props.comercio.fechainscripcion).format(
                              "YYYY-MM-DD"
                            )
                            : ""
                          : ""
                      }
                      onKeyUp={handleInputChange}
                      ref={txtFechaInscripcion}
                    />
                  </div>
                  <div className="col-6 col-lg-6 col-xl-4 m-0 mb-2 p-0 pl-2 pl-xl-0">
                    <Input label="% Retencion I.S.L.R:" inputClassName='text-end'
                      disabled={deshabilitado}
                      ref={txtIslr}
                      id="inputISLR"
                      defaultValue={
                        props.comercio && props.comercio.porcentajeretencion
                          ? props.comercio.porcentajeretencion !== null
                            ? formatMoneda(
                              props.comercio.porcentajeretencion
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )
                            : "0,00"
                          : "0,00"
                      }
                      onFocus={handleInputMontoChange}
                      onKeyUp={handleInputMontoChange}
                      onBlur={handleInputMontoChange}
                    />
                  </div>
                  <div className="col-6 col-lg-6 col-xl-4 m-0 mb-2 p-0 pl-xl-2">
                    <Input label="Capital Pagado:"
                      disabled={deshabilitado}
                      id="inputCapPag"
                      defaultValue={
                        props.comercio && props.comercio.capitalpagado
                          ? props.comercio.capitalpagado !== null
                            ? formatMoneda(
                              props.comercio.capitalpagado
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )
                            : "0,00"
                          : "0,00"
                      }
                      onFocus={seleccionarCampo}
                      onKeyUp={handleInputMontoChange}
                      onBlur={handleInputMontoChange}
                      ref={txtCapPag}
                    />
                  </div>
                  <div className="col-6 col-lg-6 col-xl-4 m-0 mb-2 p-0 pl-2">
                    <Input label='Capital Subscrito:'
                      disabled={deshabilitado}
                      id="inputCapSub"
                      defaultValue={
                        props.comercio && props.comercio.capitalsuscrito
                          ? props.comercio.capitalsuscrito !== null
                            ? formatMoneda(
                              props.comercio.capitalsuscrito
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )
                            : "0,00"
                          : "0,00"
                      }
                      onFocus={seleccionarCampo}
                      onKeyUp={handleInputMontoChange}
                      onBlur={handleInputMontoChange}
                      ref={txtCapSub}
                    />
                  </div>
                  <div className="col-12 col-xl-6 m-0 mb-2 p-0">
                    <Select label="Tipo de Contribuyente:"
                      name=""
                      disabled={deshabilitado}
                      defaultValue={
                        props.comercio && props.comercio.tipocontribuyente
                          ? props.comercio.tipocontribuyente !== null
                            ? props.comercio.tipocontribuyente.trim()
                            : ""
                          : ""
                      }
                      ref={cmbTipCont}
                    >
                      <option key="0" value="PERMANENTE">
                        PERMANENTE
                      </option>
                      <option key="1" value="TRANSEUNTE">
                        TRANSEUNTE
                      </option>
                      <option key="2" value="EVENTUAL O AMBULANTE">
                        EVENTUAL O AMBULANTE
                      </option>
                      <option key="3" value="IRREGULAR">
                        IRREGULAR
                      </option>
                    </Select>
                  </div>
                  <div className="col-12 col-xl-6 m-0 mb-2 p-0 pl-xl-2">
                    <Select label="Clase de Contribuyente:"
                      disabled={deshabilitado}
                      defaultValue={
                        props.comercio && props.comercio.clasecontribuyente
                          ? props.comercio.clasecontribuyente !== null
                            ? props.comercio.clasecontribuyente.trim()
                            : ""
                          : ""
                      }
                      ref={cmbClaseCont}
                    >
                      <option key="0" value="NORMAL">
                        NORMAL
                      </option>
                      <option key="1" value="ESPECIAL">
                        ESPECIAL
                      </option>
                      <option key="2" value="AGENTE DE RETENCION">
                        AGENTE DE RETENCION
                      </option>
                    </Select>
                  </div>
                  <div className="col-6 col-lg-4 col-xl-3 m-0 mb-2 p-0">
                    <Select label="Status:"
                      disabled={deshabilitado}
                      defaultValue={
                        props.comercio
                          ? props.comercio.status !== null
                            ? props.comercio.status
                            : ""
                          : ""
                      }
                      ref={cmbStatus}
                    >
                      {props.statuscome &&
                        props.statuscome.map((sta) => (
                          <option key={sta.idstatus} value={sta.idstatus}>
                            {sta.descripcion.trim()}
                          </option>
                        ))}
                    </Select>
                  </div>
                  <div className="col-12 col-lg-12 col-xl-7 m-0 mb-2 mb-xl-0 p-0 px-xl-2">
                    <Select label="Periodo Primera Declaración del Mes:"
                      disabled={deshabilitado}
                      ref={cmbMes}
                      defaultValue={
                        props.comercio
                          ? props.comercio.mespridecla !== null
                            ? props.comercio.mespridecla
                            : ""
                          : ""
                      }
                    >
                      <option key="0" value="1">
                        ENERO
                      </option>
                      <option key="1" value="2">
                        FEBRERO
                      </option>
                      <option key="2" value="3">
                        MARZO
                      </option>
                      <option key="3" value="4">
                        ABRIL
                      </option>
                      <option key="4" value="5">
                        MAYO
                      </option>
                      <option key="5" value="6">
                        JUNIO
                      </option>
                      <option key="6" value="7">
                        JULIO
                      </option>
                      <option key="7" value="8">
                        AGOSTO
                      </option>
                      <option key="8" value="9">
                        SEPTIEMBRE
                      </option>
                      <option key="9" value="10">
                        OCTUBRE
                      </option>
                      <option key="10" value="11">
                        NOVIEMBRE
                      </option>
                      <option key="11" value="12">
                        DICIEMBRE
                      </option>
                    </Select>
                  </div>
                  <div className="col-6 col-lg-4 col-xl-2 m-0 mb-2 mb-xl-0 p-0">
                    <Select label="Año:"
                      disabled={deshabilitado}
                      ref={cmbAnio}
                      defaultValue={
                        props.comercio
                          ? props.comercio.aniopridecla !== null
                            ? props.comercio.aniopridecla
                            : ""
                          : ""
                      }
                    >
                      {anio &&
                        anio.map((a) => (
                          <option key={a.anio} value={a.anio}>
                            {a.anio}
                          </option>
                        ))}
                    </Select>
                  </div>
                  <div className="col-12 m-0 mb-2 p-0">
                    <Textarea label='Observaciones del Status:'
                      disabled={deshabilitado}
                      ref={txtObserStatus}
                      style={{ height: 70 }}
                      id="inputObserStatus"
                      defaultValue={
                        props.comercio && props.comercio.observacionstatus
                          ? props.comercio.observacionstatus !== null
                            ? props.comercio.observacionstatus.trim()
                            : ""
                          : ""
                      }
                    />
                  </div>
                  <div className="col-12 col-xl-6 m-0 mb-2 p-0">
                    <Input label='Fecha Emision Ultima Patente:'
                      type="date"
                      disabled={deshabilitado}
                      ref={txtFechaEmisionPate}
                      id="inputFechaEmisionPate"
                      max={fechaSistema}
                      defaultValue={
                        props.comercio
                          ? props.comercio.fechaemisionpate !== null
                            ? moment.utc(props.comercio.fechaemisionpate).format(
                              "YYYY-MM-DD"
                            )
                            : ""
                          : ""
                      }
                      onKeyUp={handleInputChange}
                    />
                  </div>
                  <div className="col-12 col-xl-6 m-0 mb-2 p-0 pl-xl-2">
                    <Input label='Fecha Licencia Licores:'
                      type="date"
                      disabled={deshabilitado}
                      ref={txtFechaInscripcionlic}
                      id="inputFechaInscripcionLic"
                      max={fechaSistema}
                      defaultValue={
                        props.comercio
                          ? props.comercio.fechainscripcionlicores !== null
                            ? moment.utc(
                              props.comercio.fechainscripcionlicores
                            ).format("YYYY-MM-DD")
                            : ""
                          : ""
                      }
                      onKeyUp={handleInputChange}
                    />
                  </div>
                  <div className="col-12 m-0 p-0 d-flex gap-2">
                    Permiso Especial para Declarar:
                    <div className="col-auto m-0 p-0">
                      <Radio label="Si"
                        name="radioDeclara"
                        value="1"
                        id="radioSi"
                        disabled={
                          props.permisodecla === "0" ? true : deshabilitado
                        }
                        ref={radioDeclaraSi}
                        defaultChecked={
                          props.comercio
                            ? props.comercio.declara === 1
                              ? true
                              : false
                            : false
                        }
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Radio label="No"
                        name="radioDeclara"
                        value="0"
                        id="radioNo"
                        disabled={
                          props.permisodecla === "0" ? true : deshabilitado
                        }
                        ref={radioDeclaraNo}
                        defaultChecked={
                          props.comercio
                            ? props.comercio.declara === 0
                              ? true
                              : false
                            : false
                        }
                      />
                    </div>
                  </div>
                  <div className="col-12 m-0 p-0">
                    <Checkbox label='Impusto Pagado en Planta'
                      readOnly
                      id="checkAcreditacion"
                      disabled={deshabilitado}
                      ref={chkAcreditacion}
                      defaultChecked={
                        props.comercio ? props.comercio.acreditacion : false
                      }
                    />
                  </div>
                  <div className="col-12 m-0 p-0">
                    <Checkbox label='Posee Convenio de Pago/Permiso Patente'
                      readOnly
                      id="checkConvenio"
                      disabled={deshabilitado}
                      ref={chkConvenio}
                      defaultChecked={
                        props.comercio ? props.comercio.convenio : false
                      }
                    />
                  </div>
                  <div className="col-12 m-0 p-0">
                    <Checkbox label='Agente de Retención'
                      readOnly
                      id="checkAgente"
                      disabled={deshabilitado}
                      ref={chkAgente}
                      defaultChecked={
                        props.comercio ? props.comercio.esagentereten : false
                      }
                    />
                  </div>
                  <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
                    <legend className="float-none w-auto m-0">
                      Datos Empresa
                    </legend>
                    <div className="col-6 col-lg-4 m-0 p-0">
                      <Input label="N° de Empleados:"
                        type="number"
                        disabled={deshabilitado}
                        ref={txtNumEmpleados}
                        id="inputNumEmpleados"
                        defaultValue={
                          props.comercio && props.comercio.numempleados
                            ? props.comercio.numempleados !== null
                              ? props.comercio.numempleados
                              : "0"
                            : "0"
                        }
                        onKeyUp={handleInputChange}
                      />
                    </div>
                    <div className="col-6 col-lg-4 m-0 mb-2 mb-lg-0 p-0 pl-2">
                      <Input label="N° de Técnicos:"
                        type="number"
                        disabled={deshabilitado}
                        ref={txtNumTecnicos}
                        id="inputNumTecnicos"
                        defaultValue={
                          props.comercio && props.comercio.numtecnicos
                            ? props.comercio.numtecnicos !== null
                              ? props.comercio.numtecnicos
                              : "0"
                            : "0"
                        }
                        onKeyUp={handleInputChange}
                      />
                    </div>
                    <div className="col-6 col-lg-4 m-0 p-0 pl-lg-2">
                      <Input label="N° de Obreros:"
                        type="number"
                        disabled={deshabilitado}
                        ref={txtNumObreros}
                        id="inputNumObreros"
                        defaultValue={
                          props.comercio && props.comercio.numobreros
                            ? props.comercio.numobreros !== null
                              ? props.comercio.numobreros
                              : "0"
                            : "0"
                        }
                        onKeyUp={handleInputChange}
                      />
                    </div>
                    <div className="col-12 m-0 mt-2 p-0">
                      <Textarea label='Tipo de Negocio:'
                        style={{ height: 70 }}
                        disabled={deshabilitado}
                        ref={txtTipoNegocio}
                        id="inputTipoNegocio"
                        defaultValue={
                          props.comercio && props.comercio.tiponegocio
                            ? props.comercio.tiponegocio !== null
                              ? props.comercio.tiponegocio.trim()
                              : ""
                            : ""
                        }
                        onKeyUp={handleInputChange}
                      />
                    </div>
                  </fieldset>
                </div>
                <div className="col-12 col-lg-4 m-0 p-0">
                  <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
                    <legend className="float-none w-auto m-0">
                      Copias de Recaudos
                    </legend>
                    <div className="col-6 col-lg-12 m-0 p-0">
                      <Checkbox label='Registro de Comercio'
                        readOnly
                        id="checkRecRegComercio"
                        disabled={deshabilitado}
                        ref={chkRecRegComercio}
                        defaultChecked={
                          props.comercio
                            ? props.comercio.recregcomercio
                            : false
                        }
                      />
                    </div>
                    <div className="col-6 col-lg-12 m-0 p-0">
                      <Checkbox label='Rif'
                        readOnly
                        id="checkRecRif"
                        disabled={deshabilitado}
                        ref={chkRecRif}
                        defaultChecked={
                          props.comercio ? props.comercio.recrif : false
                        }
                      />
                    </div>
                    <div className="col-6 col-lg-12 m-0 p-0">
                      <Checkbox label='Cedula del Representante'
                        readOnly
                        id="checkRecCedulaRep"
                        disabled={deshabilitado}
                        ref={chkRecCedulaRep}
                        defaultChecked={
                          props.comercio
                            ? props.comercio.reccedularep
                            : false
                        }
                      />
                    </div>
                    <div className="col-6 col-lg-12 m-0 p-0">
                      <Checkbox label='Balance General'
                        readOnly
                        id="checkRecBalaceGeneral"
                        disabled={deshabilitado}
                        ref={chkRecBalaceGeneral}
                        defaultChecked={
                          props.comercio
                            ? props.comercio.recbalacegeneral
                            : false
                        }
                      />
                    </div>
                    <div className="col-6 col-lg-12 m-0 p-0">
                      <Checkbox label='Balance de Comprobación'
                        readOnly
                        id="checkRecBalaceComprobacion"
                        disabled={deshabilitado}
                        ref={chkRecBalaceComprobacion}
                        defaultChecked={
                          props.comercio
                            ? props.comercio.recbalacecomprobacion
                            : false
                        }
                      />
                    </div>
                    <div className="col-6 col-lg-12 m-0 p-0">
                      <Checkbox label='Estado de Ganancias y Pérdidas'
                        readOnly
                        id="checkRecBalaceGanancias"
                        disabled={deshabilitado}
                        ref={chkRecBalaceGanancias}
                        defaultChecked={
                          props.comercio
                            ? props.comercio.recbalaceganancias
                            : false
                        }
                      />
                    </div>
                    <div className="col-6 col-lg-12 m-0 p-0">
                      <Checkbox label='Planilla Declaración ISLR'
                        readOnly
                        id="checkRecDeclaracionIsrl"
                        disabled={deshabilitado}
                        ref={chkRecDeclaracionIsrl}
                        defaultChecked={
                          props.comercio
                            ? props.comercio.recdeclaracionisrl
                            : false
                        }
                      />
                    </div>
                    <div className="col-6 col-lg-12 m-0 p-0">
                      <Checkbox label='Documento Acta Constitutiva'
                        readOnly
                        id="checkRecActaConstitutiva"
                        disabled={deshabilitado}
                        ref={chkRecActaConstitutiva}
                        defaultChecked={
                          props.comercio
                            ? props.comercio.recactaconstitutiva
                            : false
                        }
                      />
                    </div>
                    <div className="col-6 col-lg-12 m-0 p-0">
                      <Checkbox label='Solvencia Municipal'
                        readOnly
                        id="checkRecSolvenciaMunicipal"
                        disabled={deshabilitado}
                        ref={chkRecSolvenciaMunicipal}
                        defaultChecked={
                          props.comercio
                            ? props.comercio.recsolvenciamunicipal
                            : false
                        }
                      />
                    </div>
                  </fieldset>
                  <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
                    <legend className="float-none w-auto m-0">Permisos</legend>
                    <div className="col-6 col-lg-12 m-0 p-0">
                      <Checkbox label='Permiso Especial Interes'
                        readOnly
                        id="checkExonIntereses"
                        disabled={
                          props.permisoexon === "0" ? true : deshabilitado
                        }
                        ref={chkExonIntereses}
                        defaultChecked={
                          props.comercio
                            ? props.comercio.exonintereses
                            : false
                        }
                      />
                    </div>
                    <div className="col-6 col-lg-12 m-0 p-0">
                      <Checkbox label='Permiso Especial Multa'
                        readOnly
                        id="checkExonMultas"
                        disabled={
                          props.permisoexon === "0" ? true : deshabilitado
                        }
                        ref={chkExonMultas}
                        defaultChecked={
                          props.comercio ? props.comercio.exonmultas : false
                        }
                      />
                    </div>
                    <div className="col-6 col-lg-12 m-0 p-0">
                      <Checkbox label='Permiso Especial Recargo'
                        readOnly
                        id="checkExonRecargos"
                        disabled={
                          props.permisoexon === "0" ? true : deshabilitado
                        }
                        ref={chkExonRecargos}
                        defaultChecked={
                          props.comercio ? props.comercio.exonrecargos : false
                        }
                      />
                    </div>
                  </fieldset>
                </div>
              </div>
            </div>

            <div
              className="tab-pane fade"
              id="historico"
              role="tabpanel"
              aria-labelledby="hist-tab"
            >
              <TablaDeudaComercio
                tabdeuda={props.tabdeuda}
                credito={props.comercio ? props.comercio.credito : "0,00"}
                idcomercio={props.comercio ? props.comercio.idcomercio : ""}
                renderDeuda={props.renderDeuda}
              />
            </div>
            <div
              className="tab-pane fade"
              id="local"
              role="tabpanel"
              aria-labelledby="local-tab"
            >
              <MapaLocalizacion
                latitud={coordenadas.latitud}
                longitud={coordenadas.longitud}
                onLocationChange={handleLocationChange}
                operacion={props.operacion}
                editable={operacion === 1 || operacion === 2 ? true : false}
              />
            </div>

            <div
              className="tab-pane fade"
              id="multas"
              role="tabpanel"
              aria-labelledby="multas-tab"
            >
              <TablaPagosComercio
                tabpago={props.tabpago}
                idcomercio={props.comercio ? props.comercio.idcomercio : ""}
              />
            </div>

            <div
              className="tab-pane fade"
              id="tabs6"
              role="tabpanel"
              aria-labelledby="pagoweb"
            >
              <TablaFacturasContribuyente
                tabfacC={props.tabpagow}
                operacion={operacion}
              />
            </div>

            {(props.comercio && props.comercio.esagentereten) &&
              <div
                className="tab-pane fade"
                id="tabs7"
                role="tabpanel"
                aria-labelledby="retenciones"
              >
                <TablaHistoricoRetenciones
                  tabreten={props.tabreten}
                  operacion={props.operacion}
                />
              </div>
            }

            <div
              className="tab-pane fade"
              id="tabs8"
              role="tabpanel"
              aria-labelledby="dm"
            >
              <TablaMultasComercio
                tabmulta={props.tabmulta}
                idcomercio={props.comercio ? props.comercio.idcomercio : ""}
              />
            </div>

            <div
              className="tab-pane fade"
              id="factpag"
              role="tabpanel"
              aria-labelledby="factpag-tab"
            >
              <TablaFacturasPagas idcomercio={props.comercio ? props.comercio.idcomercio : ""} tabfacC={props.factpago} />
            </div>
            <div
              className="tab-pane fade"
              id="factpag2"
              role="tabpanel"
              aria-labelledby="factpag-tab2"
            >
              <TablaPagosEtax tabreten={props.factpagoetax} />
            </div>
            <div
              className="tab-pane fade"
              id="factpag3"
              role="tabpanel"
              aria-labelledby="factpag-tab3"
            >
              <TablaOtrosPagosEtax tabreten={props.factotropagoetax} />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          disabled={operacion === 4 ? true : false}
          onClick={onChangeValidar}
          ref={btnAcepta}
        >
          Aceptar
        </SuccessButton>
        <DangerButton
          ref={btnCancela}
          onClick={cancelar}
        >
          Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({
              mostrar: false,
              titulo: "",
              texto: "",
              icono: "",
            });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
      <MensajeCapcha
        show={mostrar7}
        onHideAcepta={validarCapcha}
        onHideCancela={handleCancelaCapcha}
      />
      <Dimmer active={activate}></Dimmer>
      <CatalogoActividadEconomica
        titulo={titulo}
        mensaje={msg}
        show={mostrar2}
        onHideCancelaCatActi={handleCloseCatalogoActi}
        onHideAceptaCatActi={handleAceptaCatalogoActi}
      />
      <CatalogoPersona
        titulo={titulo}
        mensaje={msg}
        show={mostrar3}
        onHideCancelaCatPer={handleCloseCatalogoPer}
        onHideAceptaCatPer={handleAceptaCatalogoPer}
      />
      <CatalogoInmueble
        titulo={titulo}
        mensaje={msg}
        show={mostrar4}
        onHideCancelaCatInm={handleCloseCatalogoInm}
        onHideAceptaCatInm={handleAceptaCatalogoInm}
      />
      <CatalogoUsuarioWeb
        titulo={titulo}
        mensaje={msg}
        show={mostrar6}
        onHideCancelaCatUsuWeb={handleCloseCatalogoUsuW}
        onHideAceptaCatUsuW={handleAceptaCatalogoUsuW}
      />
    </Modal>
  );
};
